import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const ChartCard = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* BASIC CHARTS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Chart Cards</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Bar Chart</label>
            <div className="flex items-end gap-2 h-32 p-2">
              {[30, 60, 45, 75, 55].map((val, i) => (
                <div key={i} className="flex-1 bg-amber-400 rounded-t" style={{height: `${val/75*100}%`}}></div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex items-end gap-2 h-32">
  {data.map(val => (
    <div className="flex-1 bg-amber-400 rounded-t" style={{height: val + "%"}} />
  ))}
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Line Chart Display</label>
            <svg className="w-full h-32" viewBox="0 0 200 100">
              <polyline points="10,70 40,50 70,60 100,30 130,50 160,40 190,20" fill="none" stroke="#FBBF24" strokeWidth="2"/>
              <polyline points="10,70 40,50 70,60 100,30 130,50 160,40 190,20" fill="url(#grad)" opacity="0.3"/>
              <defs>
                <linearGradient id="grad" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" style={{stopColor: "#FBBF24", stopOpacity: 0.5}}/>
                  <stop offset="100%" style={{stopColor: "#FBBF24", stopOpacity: 0}}/>
                </linearGradient>
              </defs>
            </svg>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<svg viewBox="0 0 200 100">
  <polyline points="10,70 40,50 70,60 100,30" stroke="#FBBF24" strokeWidth="2" />
</svg>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Pie Chart Segments</label>
            <div className="flex items-center justify-center h-32">
              <svg width="100" height="100" viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="40" fill="none" stroke="#FBBF24" strokeWidth="15" strokeDasharray="62.8 0"/>
                <circle cx="50" cy="50" r="40" fill="none" stroke="#A78BFA" strokeWidth="15" strokeDasharray="31.4 62.8" style={{transform: "rotate(90deg)", transformOrigin: "50% 50%"}}/>
                <circle cx="50" cy="50" r="40" fill="none" stroke="#EC4899" strokeWidth="15" strokeDasharray="31.4 62.8" style={{transform: "rotate(180deg)", transformOrigin: "50% 50%"}}/>
              </svg>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<svg viewBox="0 0 100 100">
  <circle cx="50" cy="50" r="40" fill="none" stroke="#FBBF24" strokeDasharray="62.8" />
</svg>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Heatmap</label>
            <div className="grid grid-cols-5 gap-1">
              {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15].map((i, idx) => (
                <div key={i} className="w-full aspect-square rounded" style={{backgroundColor: `hsl(200, 70%, ${50 + idx * 3}%)`}}></div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="grid grid-cols-5 gap-1">
  {items.map((i, idx) => (
    <div style={{backgroundColor: \`hsl(200, 70%, \${50 + idx * 3}%)\`}} />
  ))}
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Stacked Bar</label>
            <div className="space-y-1">
              {[{a: 40, b: 30, c: 30}, {a: 50, b: 25, c: 25}, {a: 35, b: 35, c: 30}].map((bar, i) => (
                <div key={i} className="flex gap-1 h-6">
                  <div className="bg-amber-400" style={{width: bar.a + "%"}}></div>
                  <div className="bg-amber-400" style={{width: bar.b + "%"}}></div>
                  <div className="bg-amber-500" style={{width: bar.c + "%"}}></div>
                </div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-1 h-6">
  <div className="bg-amber-400" style={{width: a + "%"}} />
  <div className="bg-amber-400" style={{width: b + "%"}} />
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Mini Stats</label>
            <div className="grid grid-cols-2 gap-2">
              {[{label: "Up 23%", color: "green"}, {label: "Down 12%", color: "red"}, {label: "New 5", color: "blue"}, {label: "Pending 3", color: "amber"}].map(stat => (
                <div key={stat.label} className={`px-2 py-2 rounded text-xs font-medium text-center ${stat.color === "green" ? "bg-green-900 text-green-300" : stat.color === "red" ? "bg-red-900 text-red-300" : stat.color === "blue" ? "bg-blue-900 text-blue-300" : "bg-amber-900 text-amber-300"}`}>
                  {stat.label}
                </div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="grid grid-cols-2 gap-2">
  <div className="bg-green-900 text-green-300 px-2 py-2 rounded">Up 23%</div>
  <div className="bg-red-900 text-red-300 px-2 py-2 rounded">Down 12%</div>
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED CHARTS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Charts</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Gauge Chart</label>
            <div className="flex items-center justify-center h-32">
              <svg width="120" height="70" viewBox="0 0 120 70">
                <path d="M 10 60 A 50 50 0 0 1 110 60" fill="none" stroke="#334155" strokeWidth="8"/>
                <path d="M 10 60 A 50 50 0 0 1 85 20" fill="none" stroke="#06B6D4" strokeWidth="8"/>
                <circle cx="60" cy="60" r="4" fill="#06B6D4"/>
              </svg>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<svg viewBox="0 0 120 70">
  <path d="M 10 60 A 50 50 0 0 1 110 60" stroke="#334155" />
  <path d="M 10 60 A 50 50 0 0 1 85 20" stroke="#06B6D4" />
</svg>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChartCard;


